import { Columns3Cog } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const DataEngineeringIcon = createLucideIcon(Columns3Cog);
